module.exports = __webpack_public_path__ + "img/63.78b961de.jpg";